import { render, staticRenderFns } from "./InputUseNeedsMeal.vue?vue&type=template&id=5b007251&lang=pug"
import script from "./InputUseNeedsMeal.vue?vue&type=script&lang=ts"
export * from "./InputUseNeedsMeal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports